export function arePointsEqual(a: uui.domain.Point, b: uui.domain.Point): boolean {
  return a.x === b.x && a.y === b.y
}
